export default {
  model: [
    {
      label: 'Título',
      field: 'title',
      type: 'text'
    },
    {
      label: 'Texto',
      field: 'content',
      type: 'text'
    },
    {
      label: 'Índice',
      field: 'indice_id',
      type: 'text'
    },
    {
      label: 'Permissão de acesso',
      field: 'magazines',
      type: 'array'
    },
    {
      label: 'Data de publicação',
      field: 'publish_date',
      type: 'text',
    }
  ]
}